// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"6521":"css/admin-app.6864","6931":"css/app.6864"}[chunkId] + ".css";
};